import React from 'react';
import { NeoButton } from '../../../../../components/Common';

const ProfileHeaderActions = ({
    onNewSale,
    onActivateMember,
    onDeactivateMember,
    onEdit,
    onSave,
    onCancel,
    onDelete,
    isEditing,
    canCreateSale,
    canActivateMember,
    canDeactivateMember,
    canDeleteMember,
}) => {
    return (
        <div className="d-flex gap-2" style={{ fontFamily: 'Outfit, sans-serif' }}>
            {!isEditing && canActivateMember && (
                <NeoButton
                    variant="warning"
                    onClick={onActivateMember}
                    icon="mdi-account-check-outline"
                    size="sm"
                    className="px-3"
                >
                    Ativar Aluno
                </NeoButton>
            )}
            {!isEditing && canDeactivateMember && (
                <NeoButton
                    variant="danger"
                    onClick={onDeactivateMember}
                    icon="mdi-account-cancel-outline"
                    size="sm"
                    className="px-3"
                >
                    Inativar Aluno
                </NeoButton>
            )}
            {!isEditing && canCreateSale && (
                <NeoButton
                    variant="outline-primary"
                    title="Nova Venda"
                    onClick={onNewSale}
                    icon="mdi-cart-plus"
                    size="sm"
                    square
                />
            )}

                {isEditing ? (
                <>
                    <NeoButton
                        variant="outline-secondary"
                        onClick={onCancel}
                        size="sm"
                        className="px-3"
                    >
                        Cancelar
                    </NeoButton>
                    <NeoButton
                        variant="primary"
                        onClick={onSave}
                        size="sm"
                        className="px-3"
                    >
                        Salvar
                    </NeoButton>
                </>
            ) : (
                <>
                    <NeoButton
                        variant="outline-primary"
                        title="Editar Perfil"
                        onClick={onEdit}
                        icon="mdi-pencil-outline"
                        size="sm"
                        square
                    />
                    {canDeleteMember && (
                        <NeoButton
                            variant="outline-danger"
                            title="Excluir Membro"
                            onClick={onDelete}
                            icon="mdi-delete-outline"
                            size="sm"
                            square
                        />
                    )}
                </>
            )}
        </div>
    );
};

export default ProfileHeaderActions;
